import { hooks, site, blocks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackBlockDeleted = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_BEFORE_BLOCK_DELETED,
    ({ blockId, variationId: blockVariationId }) => {
      if (!blockId) return;

      const isBlockWidget = blockId.startsWith('widget-');
      if (isBlockWidget) return;

      const block = blocks.accessors.getBlock(blockId);

      trackEvent(constants.events.BLOCK_DELETED, {
        blockId,
        blockVariationId,
        pageId: site.accessors.getActivePageId(),
        premiumBlock: !!block.premium,
      });
    }
  );
};

export default trackBlockDeleted;
